<template>
  <div class="material"></div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.material {
  position: absolute;
  left: 120px;
  top: 50%;
  width: 41px;
  height: 43px;
  background: url("../../../../../images/head-material.png") 0 0 no-repeat;
  background-size: 100% 100%;
  transform: translate(0, -50%);
  z-index: 1;
}
</style>
